/* eslint-disable react/prop-types */
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { Form } from '@unform/web';

import { Container, Modal, ModalBody, ModalFooter } from 'reactstrap';
import {
  FaCheck,
  FaEye,
  FaMotorcycle,
  FaPlus,
  FaPrint,
  FaTimes,
} from 'react-icons/fa';
import api2 from '~/services/api2';
import DeleteItemOrders from '~/components/Orders/DeleteItemOrders';
import EyeModalOrders from '~/components/EyeModalOrders';
import IfoodOnDemand from '~/components/Delivery/IfoodOnDemand';
import { useAuth } from '~/context/AuthContext';

import { useMotoboys } from '~/context/MotoboysContext';
import {
  Button,
  ActionButton,
  DefaultSelect,
  Checkbox,
  Tabs,
} from 'ui-kit-takeat';
import CreateMotoboy from '~/pages/Motoboys/Create';
import TableEditDelivery from '~/components/Operation/TablesOperation/TableEditDelivery';
import { SiIfood } from 'react-icons/si';
import PersonalButton from '~/components/Buttons/PersonalButton';
import PreparationTime from '~/components/Delivery/PreparationTime';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import PrintDeliveryButton from '~/components/Orders/Items/PrintDeliveryButton';
import {
  Print,
  PrintOutline,
  Footer,
  ContainerOrders,
  ButtonCancel,
  ModalContainer,
  ModalContainerHeader,
  CardContainer,
  Actions,
  ButtonCheck,
  DisplayNoneImprimir,
  DeliveryInfo,
  DeliveryTime,
  NameClient,
  PhoneClient,
  InfoClientDelivery,
} from './styles';
import {
  PhoneNumber,
  CardBody,
  UserDeliveryInfo,
  UserDeliveryInfoArea,
} from '../styles';
import { DeliveryCardHeader } from '../DeliveryCardHeader';
import ReactToPrint from 'react-to-print';
import PrintNewOrderComponent from '~/components/PrintNewOrderComponent';
import {
  IconClose,
  IconIfood,
  IconMotorcycle,
  TabGroup,
  Button as DSButton,
  IconPlus,
  Modal as DSModal,
  IconArrowFoward,
  IconClipboardCheck,
} from 'takeat-design-system-ui-kit';
import { format } from 'date-fns';
import { addMessageWhatsapp } from 'utils/handleNotifyWhatsapp';

export default function OrderAndamentoDelivery({
  style,
  item,
  handleCancelItem,
  handleItemReady,
  handleUpdate,
  hasOrderBy,
  isOngoing,
}) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [btnDisable, serBtnDisable] = useState(false);
  const [, setSession] = useState(null);
  const { motoboys } = useMotoboys();
  const { user } = useAuth();
  const [changeStatusModal, setChangeStatusModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const initialData = {
    motoboy: {
      value: motoboys[0]?.id,
      label: motoboys[0]?.name,
    },
  };

  const [modalDelete, setModalDelete] = useState(false);
  const toggleDelete = () => setModalDelete(!modalDelete);

  const [modalDeleteDelivery, setModalDeleteDelivery] = useState(false);
  const toggleDeleteDelivery = () => {
    setModalDeleteDelivery(!modalDeleteDelivery);
    serBtnDisable(!btnDisable);
  };

  const [motoboyTab, setMotoboyTab] = useState(0);

  const [creatingMotoboy, setCreatingMotoboy] = useState(false);
  const [modalMotoboy, setModalMotoboy] = useState(false);

  const [motoboySelected, setMotoboySelected] = useState(() => {
    return user.use_foody_delivery
      ? { label: 'Motoboy Padrão Foody', value: null }
      : null;
  });
  const toggleModalMotoboy = () => {
    setModalMotoboy(!modalMotoboy);

    // onDemandData && setOnDemandData(null);
    // onDemandError && setOnDemandError(null);
    // motoboyTab === 1 && setMotoboyTab(0);
  };

  const [sendMsgMotoboy, setSendMsgMotoboy] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:sendMsgMotoboy')) || false
  );

  const toggleMsgMotoboy = () => {
    setSendMsgMotoboy(!sendMsgMotoboy);
    localStorage.setItem('@gddashboard:sendMsgMotoboy', !sendMsgMotoboy);
  };

  const [orders, setOrders] = useState([]);

  const getOrders = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );

      setOrders(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  const getSession = async () => {
    const response = await api2.get(
      `/restaurants/delivery/session-orders/${item.session_id}`
    );

    setSession(response.data?.orders[0]);
  };

  useEffect(() => {
    if (modalDelete) {
      getSession();
    }
  }, [modalDelete, getSession]);

  const getOrdersAndNotify = useCallback(async () => {
    try {
      // essa request é feita pra atualizar as orders quer irão ser enviadas
      // para o whatsapp do motoboy
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );

      const orders = response.data;
      addMessageWhatsapp({ item, orders, user, status: 'motoboy' });
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  useEffect(() => {
    if (modalDelete) {
      getOrders();
    }
  }, [modalDelete, getOrders]);

  const componentRef = useRef(null);

  const [loadingPrinter, setLoadingPrinter] = useState(false);

  async function printClick() {
    try {
      await api2.post('restaurants/printers/printer-queue', {
        order_basket_id: item.basket.id,
        order_type: 'new_order',
      });
      toast.success('Pedido impresso.');
    } catch (error) {
      toast.error('Erro ao imprimir pedido.');
    }
  }

  async function printDeliverySession() {
    setLoadingPrinter(true);
    try {
      await api2.post('restaurants/printers/printer-queue', {
        table_session_id: item.session_id,
        is_delivery: true,
      });

      toast.success('Pedido enviado para impressão.');
    } catch (error) {
      toast.error('Erro ao imprimir pedido.');
    }
    setLoadingPrinter(false);
  }

  const userNameDelivery = item?.buyer
    ? item.buyer.phone
      ? item.buyer.phone
      : item.buyer.ifood_phone
      ? item.buyer.ifood_phone
      : item.buyer.neemo_phone || ''
    : item?.waiter?.name;

  const [sendingMotoboy, setSendingMotoboy] = useState(false);

  const handleAddMotoboy = async (data) => {
    setSendingMotoboy(true);
    try {
      const response = await api2.post('/restaurants/motoboys/relate', {
        motoboy_id: motoboySelected.value,
        session_id: item.session_id,
        is_foody: motoboySelected.value === null,
      });

      item.motoboy = response.data;

      toast.success('Motoboy adicionado à entrega');
      toggleModalMotoboy();
      handleItemReady(
        item.basket.id,
        item.basket.ifood_id,
        item.with_withdrawal,
        null,
        hasOrderBy ? 'ongoing' : null
      );
      if (item.foody_delivery_session_id) {
        // getAllOrders();
      }
      if (!item.basket.ifood_id) {
        addMessageWhatsapp({ item, orders, user, status: 'ready' });
      }

      if (sendMsgMotoboy && motoboySelected.phone) {
        getOrdersAndNotify();
      }

      setSendingMotoboy(false);
    } catch (err) {
      setSendingMotoboy(false);
      console.log('handleAddMotoboy Error: ', err);
      toast.error('Não foi possível adicionar motoboy à essa entrega');
    }
  };

  const browserZoomLevel = Math.round(window.devicePixelRatio * 100);

  const updateStatus = async (
    basketId,
    ifood_id = null,
    withWithdrawal,
    ifood_on_demand_id = null,
    status
  ) => {
    setLoading(true);
    await handleItemReady(
      basketId,
      ifood_id,
      withWithdrawal,
      ifood_on_demand_id,
      status
    )
      .then(() => {
        // getOrders();
        // getAllOrders();
      })
      .catch((error) => {
        console.log(error);
        toast.error('Erro ao atualizar status do pedido');
      })
      .finally(() => {
        setLoading(false);
        setChangeStatusModal(false);
      });
  };

  const [preparingTimeBasket, setPreparingTimeBasket] = useState('0h0m');
  const [stepTime, setStepTime] = useState('0h0m');

  useEffect(() => {
    const calcularDiferencaHorasMinutos = (dataInicio) => {
      const startDate = new Date(
        new Date(dataInicio).toLocaleString('en-US', {
          timeZone: 'America/Sao_Paulo',
        })
      );
      const diffMs = Date.now() - startDate.getTime();

      if (diffMs < 0) return '0h0m'; // Evita valores negativos

      const horas = Math.floor(diffMs / (1000 * 60 * 60));
      const minutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      return `${horas}h${minutos}m`;
    };

    const atualizarTempos = (dataInicio) => {
      setStepTime(calcularDiferencaHorasMinutos(dataInicio));
      setPreparingTimeBasket(
        calcularDiferencaHorasMinutos(item.basket.start_time)
      );
    };

    let timeout;
    let interval;

    const iniciarAtualizacao = (dataInicio) => {
      if (!dataInicio) return;

      // Atualiza imediatamente ao renderizar
      atualizarTempos(dataInicio);

      // Calcula o tempo até a próxima virada de minuto
      const now = new Date();
      const msAteProximoMinuto = (60 - now.getSeconds()) * 1000;

      timeout = setTimeout(() => {
        atualizarTempos(dataInicio); // Atualiza exatamente na virada do minuto

        interval = setInterval(() => {
          atualizarTempos(dataInicio); // Atualiza a cada 1 minuto
        }, 60000);
      }, msAteProximoMinuto);
    };

    if (item?.basket?.order_status === 'accepted' && item?.accepted_at) {
      iniciarAtualizacao(item.accepted_at);
    } else if (item?.basket?.order_status === 'ready' && item?.ready_at) {
      iniciarAtualizacao(item.ready_at);
    } else if (item?.basket?.order_status === 'ongoing' && item?.ongoing_at) {
      iniciarAtualizacao(item.ongoing_at);
    }

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [item]);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  return (
    <CardContainer style={style}>
      <iframe ref={iframeRef} style={{ display: 'none' }} />

      <DeliveryCardHeader item={item} isOngoing={isOngoing} />

      {!item.scheduled_to && (
        <PreparationTime
          kanbanType={item.basket.order_status}
          preparingTime={preparingTimeBasket}
          stepTime={stepTime}
        />
      )}
      <CardBody>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 6,
          }}
        >
          {item?.buyer?.name && (
            <NameClient style={{ fontWeight: 600 }}>
              {item?.buyer?.name}{item?.buyer?.has_observation && <span title="Há uma observação sobre este cliente" style={{ marginLeft: 4, display: 'inline-flex' }}><IconClipboardCheck fontSize={14} fill="#FFA814" /></span>}
            </NameClient>
          )}
          {item?.basket?.schedule && (
            <PhoneClient>
              <strong>{item?.basket?.schedule}</strong>
            </PhoneClient>
          )}
          <PhoneClient>{userNameDelivery}</PhoneClient>
          {!item?.with_withdrawal && (
            <UserDeliveryInfoArea>
              {item?.buyer?.delivery_address?.neighborhood && (
                <InfoClientDelivery>
                  Bairro: {item?.buyer?.delivery_address?.neighborhood}-{' '}
                  {item?.buyer?.delivery_address?.city}
                </InfoClientDelivery>
              )}

              {item?.buyer?.delivery_address?.zip_code && (
                <InfoClientDelivery>
                  CEP: {item?.buyer?.delivery_address?.zip_code}
                </InfoClientDelivery>
              )}
            </UserDeliveryInfoArea>
          )}
          {item?.motoboy?.name && (
            <UserDeliveryInfo>
              <strong>Motoboy:</strong> {item.motoboy?.name}
            </UserDeliveryInfo>
          )}

          {item?.ifood_delivery_time && (
            <DeliveryInfo>
              <span>Previsão de entrega:</span>{' '}
              <DeliveryTime>
                {format(new Date(item.ifood_delivery_time), "HH'h'mm")}
              </DeliveryTime>
            </DeliveryInfo>
          )}
        </div>
        <Actions>
          <ButtonCheck
            type="button"
            disabled={loading}
            onClick={() => {
              if (user.use_foody_delivery) {
                if (!hasOrderBy) {
                  updateStatus(
                    item.basket.id,
                    null,
                    item.with_withdrawal,
                    null,
                    isOngoing ? 'delivered' : 'ready'
                  );
                  if (
                    user.use_foody_delivery &&
                    item.with_withdrawal &&
                    !isOngoing
                  ) {
                    console.log('retirada com foody');
                    addMessageWhatsapp({ item, orders, user, status: 'ready' });
                  }
                } else if (
                  !item?.with_withdrawal &&
                  (motoboys.length > 0 ||
                    (user.has_ifood &&
                      user?.delivery_info?.use_ifood_on_demand))
                ) {
                  toggleModalMotoboy();
                  // getOrders();
                } else {
                  updateStatus(
                    item.basket.id,
                    item.basket.ifood_id,
                    item.with_withdrawal,
                    null,
                    'delivered'
                  );
                  if (
                    !item.basket.ifood_id &&
                    !user.use_foody_delivery &&
                    !isOngoing
                  ) {
                    addMessageWhatsapp({ item, orders, user, status: 'ready' });
                  }
                }
              } else if (
                !item?.with_withdrawal &&
                (motoboys.length > 0 ||
                  (user.has_ifood && user?.delivery_info?.use_ifood_on_demand))
              ) {
                if (!hasOrderBy && user.delivery_info.use_all_kanbans) {
                  updateStatus(
                    item.basket.id,
                    null,
                    item.with_withdrawal,
                    null,
                    isOngoing ? 'delivered' : 'ready'
                  );
                  if (
                    user.use_foody_delivery &&
                    item.with_withdrawal &&
                    !isOngoing
                  ) {
                    console.log('retirada sem foody');
                    addMessageWhatsapp({ item, orders, user, status: 'ready' });
                  }
                } else if (!user.delivery_info.use_all_kanbans) {
                  toggleModalMotoboy();
                  // getOrders();
                } else {
                  toggleModalMotoboy();
                  // getOrders();
                }
              } else {
                const status =
                  user.delivery_info.use_all_kanbans && hasOrderBy
                    ? 'delivered'
                    : null;
                updateStatus(
                  item.basket.id,
                  item.basket.ifood_id,
                  item.with_withdrawal,
                  null,
                  status
                );
                if (
                  status !== 'delivered' &&
                  !item.basket.ifood_id &&
                  !isOngoing
                ) {
                  addMessageWhatsapp({ item, orders, user, status: 'ready' });
                }
              }
            }}
          >
            <IconArrowFoward fill="#2ec9b7" fontSize={20} />
          </ButtonCheck>
          <FaEye color="#ffa814" onClick={toggle} size={20} />

          <TableEditDelivery
            item={item}
            toggleDeleteDelivery={toggleDeleteDelivery}
            handleUpdate={handleUpdate}
          />
        </Actions>
      </CardBody>
      <Modal
        isOpen={changeStatusModal}
        toggle={() => setChangeStatusModal(false)}
      >
        <div style={{ padding: 20 }}>
          <h3
            style={{
              fontWeight: 700,
              fontSize: 18,
              color: '#4d4d4c',
              margin: 0,
              fontFamily: 'Poppins',
            }}
          >
            Deseja marcar o pedido como {isOngoing ? 'entregue' : 'pronto'}?
          </h3>
          <div
            style={{
              display: 'flex',
              marginTop: 20,
              justifyContent: 'space-between',
            }}
          >
            <PersonalButton
              onClick={() => setChangeStatusModal(false)}
              message="Nao"
              color="#FF2C3A"
              style={{ margin: 0 }}
            />
            <PersonalButton
              color="#2EC9B7"
              style={{ margin: 0 }}
              message={loading ? 'Aguarde...' : 'Sim'}
              disabled={loading}
              onClick={() => {
                console.log('@@ isOngoing', isOngoing, hasOrderBy);
                updateStatus(
                  item.basket.id,
                  null,
                  item.with_withdrawal,
                  null,
                  isOngoing ? 'delivered' : 'ready'
                );
                if (
                  user.use_foody_delivery &&
                  item.with_withdrawal &&
                  !isOngoing
                ) {
                  addMessageWhatsapp({ item, orders, user, status: 'ready' });
                }
              }}
            />
          </div>
        </div>
      </Modal>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalBody>
          <ContainerOrders browserZoomLevel={browserZoomLevel}>
            <EyeModalOrders item={item} />
          </ContainerOrders>
        </ModalBody>
        <Footer
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 20,
          }}
        >
          <PrintDeliveryButton
            item={item}
            user={user}
            printClick={printClick}
            printDeliverySession={printDeliverySession}
            loadingPrinter={loadingPrinter}
            handleFetchDataToPrint={handleFetchDataToPrint}
            fetchDataPayload={{
              print_type: 'table_session',
              table_session_id: item.session_id,
              is_delivery: true,
            }}
          />
        </Footer>
      </Modal>
      <Modal isOpen={modalDeleteDelivery} toggle={toggleDeleteDelivery}>
        <ModalBody>
          <Container>
            <h3>Tem certeza que deseja recusar o pedido?</h3>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button
            inverted
            onClick={() => toggleDeleteDelivery()}
            title="Desistir"
          />
          <Button
            title="Recusar o pedido"
            onClick={() =>
              handleCancelItem({
                from: 'accepted',
                order_basket_id: item.basket.id,
                session_id: item.session_id,
                ifood_id: item.basket.ifood_id,
              })
            }
          />
        </ModalFooter>
      </Modal>
      <DSModal
        open={modalMotoboy}
        toggle={toggleModalMotoboy}
        style={{
          width: '500px',
          height: 'fit-content',
          padding: 16,
          minWidth: 'unset',
        }}
      >
        {/* Aqui que fica a disponibilidade de selecionar o Entrega Fácil */}
        {user.has_ifood &&
          user?.delivery_info?.use_ifood_on_demand &&
          !item?.basket?.ifood_id &&
          item?.buyer?.delivery_address?.latitude &&
          item?.buyer?.delivery_address?.longitude && (
            <div>
              <TabGroup
                variant="transparent"
                tabs={[
                  {
                    text: 'Motoboy próprio',
                    icon: <IconMotorcycle style={{ fill: '#c8131b' }} />,
                  },
                  {
                    text: 'Entrega Fácil iFood',
                    icon: <IconIfood style={{ fill: '#c8131b' }} />,
                  },
                ]}
                onTabChange={(e) => setMotoboyTab(e)}
                value={motoboyTab}
              />
            </div>
          )}

        {motoboyTab === 0 && (
          <div>
            {creatingMotoboy ? (
              <CreateMotoboy
                toggleModalRegisterMotoboy={() => setCreatingMotoboy(false)}
                motoboyCreated={(data) => {
                  setMotoboySelected(data);
                  setCreatingMotoboy(false);
                }}
              />
            ) : (
              <Form onSubmit={handleAddMotoboy} initialData={initialData}>
                <ModalContainer style={{ padding: 0 }}>
                  <ModalContainerHeader>
                    <h3>Adicionar motoboy a essa entrega?</h3>
                    <IconClose
                      style={{ fontSize: 20, fill: '#c8131b' }}
                      onClick={() => toggleModalMotoboy()}
                    />
                  </ModalContainerHeader>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '20px',
                    }}
                  >
                    <DefaultSelect
                      name="motoboy"
                      width="-webkit-fill-available"
                      options={motoboys.map((m) => {
                        return { value: m.id, label: m.name, phone: m.phone };
                      })}
                      value={motoboySelected}
                      onChange={(e) => setMotoboySelected(e)}
                    />

                    <DSButton
                      icon={<IconPlus />}
                      color="green"
                      onClick={() => setCreatingMotoboy(true)}
                    />
                  </div>

                  {user.use_wpp &&
                    motoboySelected !== null &&
                    motoboySelected?.value && (
                      <div>
                        <Checkbox
                          checked={sendMsgMotoboy && motoboySelected.phone}
                          label="Enviar detalhes do pedido para motoboy"
                          onClick={() => toggleMsgMotoboy()}
                          disabled={!motoboySelected.phone}
                        />

                        {!motoboySelected.phone && (
                          <span style={{ color: 'red' }}>
                            Este motoboy não possui telefone cadastrado
                          </span>
                        )}
                      </div>
                    )}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <DSButton
                      onClick={(e) => {
                        e.preventDefault();
                        toggleModalMotoboy();
                        updateStatus(
                          item.basket.id,
                          item.basket.ifood_id,
                          item.with_withdrawal,
                          null,
                          hasOrderBy ? 'ongoing' : null
                        );
                        if (!item.basket.ifood_id) {
                          addMessageWhatsapp({
                            item,
                            orders,
                            user,
                            status: 'ready',
                          });
                        }
                      }}
                      title="Não adicionar motoboy"
                      disabled={sendingMotoboy}
                      isLoading={sendingMotoboy}
                    >
                      Não adicionar motoboy
                    </DSButton>
                    <DSButton
                      type="submit"
                      onClick={() => {}}
                      disabled={sendingMotoboy}
                      isLoading={sendingMotoboy}
                      color="green"
                    >
                      Adicionar
                    </DSButton>
                  </div>
                </ModalContainer>
              </Form>
            )}
          </div>
        )}

        {motoboyTab === 1 && (
          <IfoodOnDemand
            item={item}
            user={user}
            handleItemReady={handleItemReady}
            toggleModal={toggleModalMotoboy}
            orders={orders}
          />
        )}
      </DSModal>
      <Modal isOpen={modalDelete} toggle={toggleDelete}>
        <ModalBody>
          <Container>
            <DeleteItemOrders
              item={item}
              modalDelete={modalDelete}
              from="accepted"
              orders={orders}
            />
          </Container>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel
            color="danger"
            onClick={() =>
              handleCancelItem({
                order_basket_id: item.basket.id,
                from: 'accepted',
              })
            }
          >
            Cancelar todos de uma vez
          </ButtonCancel>
        </ModalFooter>
      </Modal>
      <DisplayNoneImprimir>
        <PrintNewOrderComponent
          restaurant={user}
          item={item}
          ref={componentRef}
          orders={orders}
        />
      </DisplayNoneImprimir>
    </CardContainer>
  );
}